import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Spotlight from "@/pages/home/components/Spotlight";
import DeepReads from "@/pages/home/components/DeepReads";
import Timeline from "@/pages/home/components/Timeline";
import Insights from "@/pages/home/components/Insights";
import Opinions from "@/pages/home/components/Opinions";
import Trending from "@/pages/home/components/Trending";
import AppDownload from "@/pages/home/components/AppDownload";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full flex flex-col bg-background-50">
      <Navbar />
      <main className="w-full flex-1">
        <Hero />
        <Spotlight />
        <DeepReads />
        <Timeline />
        <Insights />
        <Opinions />
        <Trending />
        <AppDownload />
      </main>
      <Footer />
    </div>
  );
}